import { render, staticRenderFns } from "./WebNoticeUpdate.vue?vue&type=template&id=50084862&scoped=true&"
import script from "./WebNoticeUpdate.vue?vue&type=script&lang=js&"
export * from "./WebNoticeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WebNoticeUpdate.vue?vue&type=style&index=0&id=50084862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50084862",
  null
  
)

export default component.exports